import { connect } from 'react-redux'
import MainHeader from '../../../ReusableComponents/Header/MainHeader'
import style from './RemoteDevice.module.css'
import { languageWords } from '../../../../utils/langaugeSupport'
import { useHistory } from 'react-router'
import { useState, useRef, useEffect } from 'react'
import Joystick from './Joystick'
import renderPrgImage from '../../../../source/programImg'

const options = ['Slow', 'Medium', 'Fast']

function RemoteDevice(props) {
    const languageName = props.device.language
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    const connectedDevice = sessionStorage.getItem('connectedDevice')

    let history = useHistory()
    const [activeIndex, setActiveIndex] = useState(0)
    const [swapped, setSwapped] = useState(false)

    const handelGoBack = () => {
        history.push('/introduction')
    }

    const handelChangeLeft = (data) => {
        console.log('Horizontal:', data.x, data.y)
    }

    const handelChangeRight = (data) => {
        console.log('Vertical:', data.x, data.y)
    }

    const getDeviceImageUrl = () => {
        switch (connectedDevice) {
            case 'Moki':
                return renderPrgImage('Moki')
            default:
                return renderPrgImage('poki')
        }
    }

    return (
        <div>
            <MainHeader
                title={languageWords[languageName]?.Joystick || 'Joystick'}
                showBluetoothBtn={true}
                isGoBack={true}
                goBack={handelGoBack}
            />
            <div className={style.joystickContainer}>
                <div className={style.joyContainer}>
                    {/* Left Joystick */}
                    <div className={style.joystickWrapperLeft}>
                        <div
                            className={`${style.joystickLeftParentDiv}  ${
                                swapped ? style.swapToRight : style.swapToLeft
                            }`}
                        >
                            <Joystick
                                type="horizontal"
                                onChange={handelChangeLeft}
                                size={'200px'}
                            />
                        </div>
                    </div>

                    {/* Center Device and Swap Button */}
                    <div className={style.btnWrapper}>
                        <img
                            className={style.device}
                            src={getDeviceImageUrl()}
                            alt="device"
                        />
                        <div className={style.btnWrapperDiv}>
                            <div
                                className={style.swipeWrapper}
                                onClick={() => setSwapped(!swapped)}
                            >
                                {/* <span className={style.swipeWrapperArrowIcon}>
                                    {'\u2190'}
                                </span>
                                <span className={style.swipeWrapperArrowIcon}>
                                    {'\u2192'}
                                </span> */}

                                <div className={style.swipeWrapperTextDiv}>
                                    <span className={style.swipeWrapperText}>
                                        Swipe
                                    </span>
                                    <span className={style.swipeWrapperText}>
                                        Control
                                    </span>
                                </div>
                            </div>

                            <div className={style.wrapper}>
                                {/* Sliding background */}
                                <div
                                    className={style.slider}
                                    style={{
                                        transform: `translateX(${
                                            activeIndex * 100
                                        }%)`,
                                    }}
                                />

                                {options.map((item, index) => (
                                    <div
                                        key={item}
                                        className={`${style.btn} ${
                                            activeIndex === index
                                                ? style.active
                                                : ''
                                        }`}
                                        onClick={() => setActiveIndex(index)}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right Joystick */}
                    <div className={style.joystickWrapperRight}>
                        <div
                            className={`${style.joystickRightParentDiv}  ${
                                swapped ? style.swapToLeft : style.swapToRight
                            }`}
                        >
                            <Joystick
                                type="vertical"
                                onChange={handelChangeRight}
                                size={'200px'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state
}

export default connect(mapStateToProps)(RemoteDevice)
